
import { fetchAccount, fetchUser, fetchPassword } from './fetch'
import updateAccount from './updateAccount'
import updateAccountLevel from './updateAccountLevel'

export default {
  fetch: fetchAccount,
  fetchAccount,
  fetchUser,
  fetchPassword,
  updateAccount,
  updateAccountLevel
}

export {
  updateAccountLevel
}
